import featureCardBg from "@assets/web-v3-images/feature-card-bg.png";
import featureCardTitleBg from "@assets/web-v3-images/feature-card-title-bg.png";
import journalIcon from "@assets/web-v3-images/icons/shwe-journal-icon.png";
import vaultIcon from "@assets/web-v3-images/icons/shwe-vault-icon.png";
import dailyRewardIcon from "@assets/web-v3-images/icons/daily-reward-icon.png";
import puzzleIcon from "@assets/web-v3-images/icons/Group 1000011693.png";
// import puzzleIcon from "@assets/web-v3-images/icons/minigame.png";
import { Trans, useTranslation } from "react-i18next";
import { IS_UPDATE_VERSION_3_PROJECT } from "@/helper/const";

/**
 * Hàng 4 card tính năng (Shwe Journal / Shwe Vault / Daily Reward / Shwe Puzzle).
 * `stats` chứa số liệu động — sau này lấy từ API rồi đẩy vào store.
 */
const FeatureCards = ({
  stats = {
    journal: { current: 12, total: 30 },
    vault: { ready: 1, pieces: 245 },
    daily: { endsIn: "3h" },
    puzzle: { freeCoins: 2, rewardsLeft: 5 },
  },
  onSelect,
}) => {
  const { t } = useTranslation();

  // `lines` giữ i18nKey + values để render bằng <Trans>: phần giá trị được bọc
  // trong thẻ <v> trong file locale nên tô màu được mà vẫn đúng trật tự từ của
  // từng ngôn ngữ (vd tiếng Miến đặt {{time}} ở đầu câu).
  const cards = IS_UPDATE_VERSION_3_PROJECT
    ? [
        {
          key: "journal",
          icon: journalIcon,
          title: t("home.cards.journal.title"),
          lines: [{ i18nKey: "home.cards.journal.day", values: stats.journal }],
          classItemTour: "intro-tour-home__step-7",
        },
        {
          key: "vault",
          icon: vaultIcon,
          title: t("home.cards.vault.title"),
          lines: [
            {
              i18nKey: "home.cards.vault.ready",
              values: { count: stats.vault.ready },
            },
            {
              i18nKey: "home.cards.vault.pieces",
              values: { count: stats.vault.pieces },
            },
          ],
          classItemTour: "intro-tour-home__step-8",
        },
        {
          key: "daily",
          icon: dailyRewardIcon,
          title: t("home.cards.daily.title"),
          lines: [
            {
              i18nKey: "home.cards.daily.endsIn",
              values: { time: stats.daily.endsIn },
            },
          ],
          classItemTour: "intro-tour-home__step-9",
        },
        {
          key: "puzzle",
          icon: puzzleIcon,
          title: t("home.cards.puzzle.title"),
          lines: null,
          classItemTour: "intro-tour-home__step-10",
        },
      ]
    : [
        {
          key: "puzzle",
          icon: puzzleIcon,
          title: t("home.cards.puzzle.title"),
          lines: null,
          classItemTour: "intro-tour-home__step-10",
        },
      ];

  const valueSpan = <span className="text-[#E62E05]" />;

  // Bề rộng mỗi card LUÔN = 1/4 hàng (như khi có đủ 4 card): (100% - 3 gap)/4.
  // Số card ít hơn 4 thì canh giữa (justify-center) chứ KHÔNG phình to ra.
  // gap-3 = 12px (mobile), sm:gap-2.5 = 10px -> trừ đúng 3 khe trong công thức.
  return (
    <section className="sm:mt-4 flex justify-center gap-1.5 sm:gap-2.5">
      {cards.map((card) => (
        <button
          key={card.key}
          type="button"
          onClick={() => onSelect?.(card.key)}
          style={{ backgroundImage: `url(${featureCardBg})` }}
          className={`@container relative aspect-195/267 w-[calc((100%-36px)/4)] shrink-0 cursor-pointer bg-size-[100%_100%] bg-no-repeat transition-transform active:scale-95 sm:w-[calc((100%-30px)/4)] ${card.classItemTour}`}
        >
          {/* Toạ độ theo design (card 195x267): icon 0→161, pill 161→211,
              stats 211→267. Dùng % để bám đúng vị trí ở mọi cỡ màn. */}
          <img
            src={card.icon}
            alt=""
            width={195}
            height={161}
            className="inset-x-0 top-0 left-0 translate-x-[5%] translate-y-[-15%] h-[60.3%] w-full object-contain"
          />
          {/* PNG 181x72: pill nằm ở 50px trên cùng, phần còn lại là glow trong
              suốt. Box lấy trọn 72px (72/267 = 26.97%) để ảnh không bị bóp;
              chữ căn giữa trong 50/72 = 69.44% phía trên = đúng thân pill. */}
          <span
            style={{ backgroundImage: `url(${featureCardTitleBg})` }}
            className="mx-auto left-1/2 top-[46.3%] flex h-[26.97%] w-[92.8%] justify-center bg-size-[100%_100%] bg-no-repeat"
          >
            {/* Lớp dưới stroke 2px = 1px lộ ra ngoài (nửa trong bị lớp gradient che) */}
            <span className="flex h-[69.44%] w-full items-center justify-center whitespace-nowrap text-[clamp(9.5px,10.5cqw,22px)] font-extrabold">
              <span className="inline-grid">
                <span
                  aria-hidden="true"
                  style={{ WebkitTextStroke: "2px #B7220D" }}
                  className="col-start-1 row-start-1 text-[#B7220D] [text-shadow:0_2px_2px_#B7220D]"
                >
                  {card.title}
                </span>
                <span className="col-start-1 row-start-1 text-transparent bg-linear-to-b from-[#FBF5DA] from-36% to-[#FDEFB0] bg-clip-text">
                  {card.title}
                </span>
              </span>
            </span>
          </span>
          {/* <span className="absolute inset-x-0 bottom-0 top-[57.03%] flex flex-col items-center justify-center px-[clamp(2px,4.1cqw,8px)] text-center text-[clamp(10px,7.69cqw,16px)] font-bold leading-snug text-[#8a3213]">
            {card.lines && card.lines.map((line) => (
              <span key={line.i18nKey}>
                <Trans
                  i18nKey={line.i18nKey}
                  values={line.values}
                  components={{ v: valueSpan }}
                />
              </span>
            ))}
          </span> */}
        </button>
      ))}
    </section>
  );
};

export default FeatureCards;
